var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "travelo-login-box sdr-box",
      attrs: { id: "sundair-login" },
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c(
        "form",
        {
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.onSubmit($event)
            },
          },
        },
        [
          _c("div", { staticClass: "form-group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.agency_login,
                  expression: "agency_login",
                },
              ],
              staticClass: "input-text full-width",
              attrs: { type: "text", placeholder: "agency login" },
              domProps: { value: _vm.agency_login },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.agency_login = $event.target.value
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.agency_password,
                  expression: "agency_password",
                },
              ],
              staticClass: "input-text full-width",
              attrs: { type: "password", placeholder: "password" },
              domProps: { value: _vm.agency_password },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.agency_password = $event.target.value
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("br"),
          _c("br"),
          _vm._v(" "),
          _vm._m(1),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "seperator" }),
      _vm._v(" "),
      _vm._m(2),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "seperator" }, [
      _c("label", [_vm._v("Hello")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("button", { staticClass: "btn-medium uppercase full-width" }, [
      _c("i", { staticClass: "soap-icon-trunk-1" }),
      _vm._v("  Login with Agency"),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("Don't have an account?  "),
      _c("a", { staticClass: "goto-signup soap-popupbox" }, [
        _vm._v("+49 30 46 79 76 00"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }